import { DefaultResponse } from "@shared/zod/schemas/responses/common"
import { OnboardingItemWithState, OnboardingOpenCount } from "@shared/zod/schemas/responses/onboarding"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const getItems = async (practiceId: string, prefix?: string): Promise<OnboardingItemWithState[]> => {
  const path = prefix
    ? `/practices/${practiceId}/onboarding/items/${prefix}`
    : `/practices/${practiceId}/onboarding/items`
  const resp = await axiosAuth({ url: path, method: "get" })
  return resp.data
}

export const getOpenCounts = async (prefix?: string): Promise<OnboardingOpenCount[]> => {
  const path = prefix ? `/onboarding/open-counts/${prefix}` : "/onboarding/open-counts"
  const resp = await axiosAuth({ url: path, method: "get" })
  return resp.data
}

export const completeItem = async (practiceId: string, key: string): Promise<DefaultResponse> => {
  const resp = await axiosAuth({
    url: `/practices/${practiceId}/onboarding/items/${key}/complete`,
    method: "post",
  })
  return resp.data
}
